import Card from '@mui/material/Card';

interface IndustryCardProps {
  text: string;
}

export const IndustryCard: React.FC<IndustryCardProps> = ({ text }) => {
  return (
    <Card
      sx={{
        backgroundColor: '#fff!important',
        borderRadius: 1,
        margin: '10px',
        minHeight: '150px',
        padding: 3,
        marginBottom: '30px',
        marginTop: '20px',
      }}
    >
      <p className='text-gray-800'>{text}</p>
    </Card>
  );
};
